import SuggestSelect from "components/common/input/SuggestSelect";
import { CorpModel, ThreadAdminListModel } from "models";
import { ThreadAdminSearchOptions } from "models/ThreadAdminSearchOptions";
import React from "react";

type PROPS = {
  corpList?: CorpModel[];
  options: ThreadAdminSearchOptions;
  data: ThreadAdminListModel;
  onSearch: () => void;
};

const ThreadAdminSearchArea: React.FC<PROPS> = (props) => {
  const [reRenderKey, setReRenderKey] = React.useState(0);
  const [receiveCorpName, setReceiveCorpName] = React.useState("");
  const [sendCorpName, setSendCorpName] = React.useState("");
  // キーワード
  const [keyword, setKeyword] = React.useState("");
  // 完了も表示
  const [isShowAll, setIsShowAll] = React.useState(false);

  const [options, setOptions] = React.useState<
    { label: string; value: string }[]
  >([]);

  const onReset = () => {
    // delete props.options.receive_corp_id;
    // delete props.options.send_corp_id;
    // delete props.options.keyword;
    // delete props.options.is_show_all;

    setReceiveCorpName("");
    setSendCorpName("");
    setKeyword("");
    setIsShowAll(false);

    setReRenderKey(reRenderKey + 1);

    for (let k in props.options) {
      delete (props.options as any)[k];
    }
    props.onSearch();
  };

  React.useEffect(() => {
    if (props.corpList) {
      const tmp = props.corpList.map((v) => {
        return { label: v.corp_name, value: v.corp_id };
      });
      setOptions(tmp);
    } else {
      setOptions([]);
    }
  }, [props.corpList]);

  React.useEffect(() => {
    setReceiveCorpName("");
    if (props.corpList) {
      if (props.options.receive_corp_id !== undefined) {
        const corp = props.corpList.find(
          (v) => v.corp_id === props.options.receive_corp_id
        );
        if (corp) {
          setReceiveCorpName(corp.corp_name);
        }
      }
      setSendCorpName("");
      if (props.options.send_corp_id !== undefined) {
        const corp = props.corpList.find(
          (v) => v.corp_id === props.options.send_corp_id
        );
        if (corp) {
          setSendCorpName(corp.corp_name);
        }
      }
    }
    if (props.options.keyword !== undefined) {
      setKeyword(props.options.keyword);
    }
    if (props.options.is_show_all === true) {
      setIsShowAll(true);
    } else {
      setIsShowAll(false);
    }
  }, [
    props.corpList,
    props.options.is_show_all,
    props.options.keyword,
    props.options.receive_corp_id,
    props.options.send_corp_id,
  ]);

  return (
    <div className="m-4 border rounded p-4 flex flex-col gap-2 threadAdminSearch">
      <div className="flex gap-8">
        <div className="w-96 flex items-center gap-4">
          <div>受注会社</div>
          <div className="flex-1">
            <SuggestSelect
              reRenderKey={reRenderKey}
              initValue={receiveCorpName}
              items={options}
              onSelect={(value: string) => {
                console.log(value);
                if (value) {
                  props.options.receive_corp_id = value;
                } else {
                  delete props.options.receive_corp_id;
                }
              }}
              leaveText={true}
            />
          </div>
        </div>
        <div className="flex-1 flex items-center gap-4">
          <div>キーワード</div>
          <div className="flex-1">
            <input
              className="w-full"
              value={keyword}
              onChange={(e) => {
                const value = e.target.value;
                setKeyword(value);
                if (value) {
                  props.options.keyword = value;
                } else {
                  delete props.options.keyword;
                }
              }}
              maxLength={50}
            />
          </div>
        </div>
      </div>
      <div className="flex gap-8">
        <div className="w-96 flex items-center gap-4">
          <div>発注会社</div>
          <div className="flex-1">
            <SuggestSelect
              reRenderKey={reRenderKey}
              initValue={sendCorpName}
              items={options}
              onSelect={(value: string) => {
                console.log(value);
                if (value) {
                  props.options.send_corp_id = value;
                } else {
                  delete props.options.send_corp_id;
                }
              }}
              leaveText={true}
            />
          </div>
        </div>
        <div className="flex-1 flex justify-end items-center gap-4">
          <label>
            <input
              type="checkbox"
              checked={isShowAll}
              onChange={(e) => {
                const value = e.target.checked;
                setIsShowAll(value);
                if (value) {
                  props.options.is_show_all = true;
                } else {
                  delete props.options.is_show_all;
                }
              }}
            />
            <span className="ml-2">商談完了も表示</span>
          </label>
          <div className="underline cursor-pointer" onClick={onReset}>
            検索条件を解除
          </div>
          <button
            className="primary px-8 py-2"
            onClick={() => {
              setReRenderKey(reRenderKey + 1);
              props.onSearch();
            }}
          >
            検索
          </button>
        </div>
      </div>
    </div>
  );
};
export default ThreadAdminSearchArea;
